import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ehaz-sso-error',
  templateUrl: './ehaz-sso-error.component.html',
  styleUrls: ['./ehaz-sso-error.component.scss'],
  imports: [TranslateModule],
})
export class EhazSsoErrorComponent {}
